import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { WhatIsInside } from './components/WhatIsInside';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
export function App() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-rose-200 selection:text-rose-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      <main data-id="element-3">
        <Hero scrollToPricing={scrollToPricing} data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Solution scrollToPricing={scrollToPricing} data-id="element-6" />
        <WhatIsInside data-id="element-7" />
        <Benefits scrollToPricing={scrollToPricing} data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Bonuses data-id="element-10" />
        <Pricing data-id="element-11" />
        <Guarantee data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}